import { Stack } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { AggregateIssuesViewStore } from '../../Stores/AggregateIssuesViewStore'
import { IssueTypeSummaryCategory } from '../molecules/IssueTypeSummaryCategory'

type Props = {
  viewStore: AggregateIssuesViewStore
}

export const IssuesTypeList = observer(({ viewStore }: Props) => {
  const theme = useMinimalsTheme()
  const { issuesCountByType } = viewStore

  return (
    <Stack flexDirection='column' gap={theme.customSpacing.l}>
      {issuesCountByType
        .filter(icbt => icbt.issueTypes.some(i => i.count > 0))
        .map(category => (
          <IssueTypeSummaryCategory
            viewStore={viewStore}
            key={category.key}
            issueTypeCategory={category}
          />
        ))}
    </Stack>
  )
})
